import {TabState, TabStateDefaults} from 'Navigation';

export default class DatasetTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Dataset',
      closeable: false,
      preferenceKey: 'dataset',
    };
  }
}
